<template>
  <div>
    <TheNavBar @click="toggleDrawer()" />
    <TheNavDrawer :status="drawer" />
    <v-container class="px-5">
      <slot />
    </v-container>
  </div>
</template>

<script>
import TheNavBar from './TheNavBar.vue';
import TheNavDrawer from './TheNavDrawer.vue';

export default {
  name: 'TheMenuLayout',
  components: {
    TheNavBar,
    TheNavDrawer,
  },
  data() {
    return {
      drawer: false,
    };
  },

  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
  },
};
</script>
